/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$defineProperties = _interopDefault(require('babel-runtime/core-js/object/define-properties'));
var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var Vue = _interopDefault(require('vue'));
var IdentityMap = _interopDefault(require('../util/identity-map'));
var minilo = require('../util/minilo');

// todo uncomment when IE 11 will die
// const IDENTITY_MAP_PROP = Symbol('identityMap')
var IDENTITY_MAP_PROP = 'identityMap';
/**
 * @alias module:mixin/ident-map
 * @title identMap
 * @vueProto
 */
var identMap = {
  IDENTITY_MAP_PROP: IDENTITY_MAP_PROP,
  props: {
    /**
     * Unique key for saving to identity map
     * @type {string|number}
     * @experimental
     */
    ident: [String, Number]
  },
  methods: {
    /**
     * @param parts
     * @return {string|undefined}
     * @protected
     */
    makeSelfIdent: function makeSelfIdent() {
      if (!this.ident) return;

      for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
        parts[_key] = arguments[_key];
      }

      return this.makeIdent.apply(this, [this.ident].concat(_toConsumableArray(parts)));
    },

    /**
     * @param parts
     * @return {string}
     */
    makeIdent: function makeIdent() {
      for (var _len2 = arguments.length, parts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        parts[_key2] = arguments[_key2];
      }

      return parts.filter(minilo.identity).join('.');
    }
  },
  created: function created() {
    initIdentityMap.call(this);
  }
};

/**
 * @private
 */
function initIdentityMap() {
  var _this = this;

  if (!this[IDENTITY_MAP_PROP]) {
    Vue[IDENTITY_MAP_PROP] = Vue.prototype[IDENTITY_MAP_PROP] = new IdentityMap();
  }
  _Object$defineProperties(this, {
    $identityMap: {
      enumerable: true,
      get: function get() {
        return _this[IDENTITY_MAP_PROP];
      }
    }
  });
}

module.exports = identMap;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/ident-map.js
// module id = 515
// module chunks = 1